import React from "react";
import AppRoute from "./routes";
import "./App.css";
//
window.__DEV__ = true;

const App = () => <AppRoute />;
export default App;
